import type { ElementType } from 'react';
import { FC } from 'react';

interface FormattedPriceProps {
  translatedPrice: string;
  AmountComponent: ElementType;
  DurationComponent?: ElementType;
}

/**
 * Splits a translated price into amount and duration parts.
 *
 * Since customers can provide custom translations, the '/' separator may not be present — in that case the full string is returned as the amount.
 */
const splitTranslatedPrice = (translatedPrice: string | undefined) => {
  if (!translatedPrice?.includes('/')) {
    return { amount: translatedPrice, duration: '' };
  }

  const [amount, duration] = translatedPrice.split('/').map((s) => s.trim());

  return { amount, duration };
};

export const FormattedPrice: FC<FormattedPriceProps> = ({
  translatedPrice,
  AmountComponent,
  DurationComponent = 'span',
}) => {
  const { amount, duration } = splitTranslatedPrice(translatedPrice);

  return (
    <>
      <AmountComponent>{amount}</AmountComponent>
      {duration && <DurationComponent> / {duration}</DurationComponent>}
    </>
  );
};
